import { AutocompleteProps } from 'core/autocomplete/autocomplete.props';

export const AutocompletePresets: AutocompleteProps = {
  labelProperty: 'name',
  options: [],
  valueProperty: 'id',
};
